import { Award, ExternalLink } from "lucide-react";
import { useContent, useLang } from "@/context/AppContext";
import { SectionHeader, Reveal } from "@/components/ui-bits";

// Credentials — colophon grid: small caps issuer, serif credential names.
export default function Certifications() {
  const { t, L } = useLang();
  const { content } = useContent();
  const certs = content?.certifications || [];

  if (!certs.length) return null;

  return (
    <section id="certifications" className="bg-obsidian py-20 lg:py-32" data-testid="certifications-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHeader eyebrow={t("certEyebrow")} title={t("certTitle")} index={6} />
        <div className="mt-12 grid border-t border-l border-hairline sm:grid-cols-2 lg:grid-cols-3">
          {certs.map((cert, i) => (
            <Reveal key={cert.id} delay={(i % 3) * 0.06} className="h-full">
              <div
                data-testid={`certification-card-${cert.id}`}
                className="group h-full border-b border-r border-hairline p-7 transition-colors duration-300 hover:bg-surface"
              >
                <span className="flex h-10 w-10 items-center justify-center border border-hairline text-vermilion transition-colors group-hover:border-vermilion/50">
                  <Award className="h-4 w-4" />
                </span>
                <h3 className="mt-6 font-display text-lg font-medium leading-snug text-bone">{L(cert.name)}</h3>
                <p className="mt-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-sand">{L(cert.issuer)}</p>
                <div className="mt-5 flex items-center justify-between gap-3 border-t border-hairline pt-4">
                  {cert.year ? (
                    <span className="font-mono text-xs font-bold text-vermilion">{cert.year}</span>
                  ) : (
                    <span />
                  )}
                  {cert.credential_url ? (
                    <a
                      href={cert.credential_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`certification-verify-${cert.id}`}
                      className="inline-flex items-center gap-1.5 font-mono text-[11px] font-bold uppercase tracking-wide text-vermilion hover:underline"
                    >
                      {t("verify")}
                      <ExternalLink className="h-3 w-3" />
                    </a>
                  ) : null}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
